import Column from "@components/column";
import Title from "@components/title";
import { Fragment, useState } from "react";
import PushNotificationForm from "./form";
import NotificationList from "./list";
import NotificationHistoryList from "./history";
import Row from "@components/row";
import styled from "@emotion/styled";
import { Helper } from "@utils/index";

const TabButton = styled.button<{ active: boolean }>`
  padding: 10px 20px;
  background: ${(props) => (props.active ? "#3b82f6" : "transparent")};
  color: ${(props) => (props.active ? "#fff" : "#6b7280")};
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;
  margin-top: 10px;

  &:hover {
    background: ${(props) => (props.active ? "#2563eb" : "#f3f4f6")};
  }
`;

const PushNotifications = () => {
  const [activeTab, setActiveTab] = useState<"broadcast" | "history">(
    "broadcast",
  );
  const user = Helper.getUser();
  const isAdmin = user?.role === "admin";

  return (
    <Fragment>
      <Column>
        <Title textone="Push" texttwo="Notifications" />

        {isAdmin && (
          <Row styleRow="margin-bottom: 20px; gap: 10px;">
            <TabButton
              active={activeTab === "broadcast"}
              onClick={() => setActiveTab("broadcast")}
            >
              Send Broadcast
            </TabButton>
            <TabButton
              active={activeTab === "history"}
              onClick={() => setActiveTab("history")}
            >
              Notification History
            </TabButton>
          </Row>
        )}

        {(!isAdmin || activeTab === "broadcast") && (
          <Fragment>
            <PushNotificationForm />
            <NotificationList />
          </Fragment>
        )}

        {isAdmin && activeTab === "history" && <NotificationHistoryList />}
      </Column>
    </Fragment>
  );
};

export default PushNotifications;
